module.exports = __webpack_public_path__ + "img/img_hula_img2.4e932a94.png";